const calpak = window.calpak

document.addEventListener("calpak:loaded", function () {
    let updatedSlidesbyGeolocation = false;
    const promoBars = document.querySelectorAll(".geolocation-promo-slide");

    function calculateDistance(lat1, lon1, lat2, lon2) {
        const R = 6371;
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;
        return {mile: distance * 0.621371, km: distance};
    }

    const fetchUserLocation = async () => {
        const cachedLocation = localStorage.getItem('userLocation');
        const cachedTime = localStorage.getItem('locationFetchTime');
        const currentTime = Date.now();

        if (cachedLocation && cachedTime && currentTime - cachedTime < 3600000) {
            const data = JSON.parse(cachedLocation);
            processLocationData(data.latitude, data.longitude);
            return;
        }

        try {
            const res = await fetch('https://api.techyscouts.io/calpak/location/index.php');
            const data = await res.json();
            if (data) {
                localStorage.setItem('userLocation', JSON.stringify({
                    latitude: data.latitude,
                    longitude: data.longitude
                }));
                localStorage.setItem('locationFetchTime', currentTime);

                processLocationData(data.latitude, data.longitude);
            }
        } catch (error) {
            return error;
        }
    };

    function processLocationData(userLatitude, userLongitude) {
        if (promoBars?.length) {
            Promise.all(Array.from(promoBars).map(async (promobar) => {
                if (promobar) {
                    const targetMile = promobar.getAttribute("data-mile");
                    const coordinates = promobar.getAttribute("data-location");
    
                    if (coordinates) {
                        const [latitude, longitude] = coordinates.split(',');
                        const totalDistance = calculateDistance(latitude, longitude, userLatitude, userLongitude);
    
                        if (totalDistance?.mile > parseInt(targetMile)) {
                            promobar.remove();
                        } else {
                            promobar.style.display = "block";
                        }
                        updatedSlidesbyGeolocation = true;
                    }
                }
            }));
        }
    }

    if (!promoBars?.length) {
        updatedSlidesbyGeolocation = true;
    }

    updatedSlidesbyGeolocation = true;

    async function initializePromoSlider() {
        if (promoBars?.length) {
            await fetchUserLocation();
        }
        if (updatedSlidesbyGeolocation) {
            let promoSlider = document.querySelector(".promo-slider");
            let promoBarMain = document.querySelector('.promo-bar');
            let promoBarCells = document.querySelectorAll('.promo-bar-text-cell');
            const country = promoSlider?.getAttribute("data-country");

            if(country != "US"){
                promoBarCells = Array.from(promoBarCells).filter(element => {
                    const style = window.getComputedStyle(element);
                    return style.display !== 'none' && style.visibility !== 'hidden';
                });
            }

            document.querySelectorAll('.promo-bar-text-cell.both')?.forEach((element) => {
                element.style.display = 'inherit';
            });

            let isPlaying = true;
            const timeout = Number.parseInt(promoSlider.dataset.timeout) * 1000;
            var slider = tns({
                container: '.promo-slider',
                items: 1,
                axis: "vertical",
                controls: false,
                center: true,
                nav: false,
                speed: 3000,
                autoplayTimeout: timeout,
                autoplay: true,
                autoplayButtonOutput: false
            });

            const updatePromoBarVisibility = () => {
                const promoBarShippingContainer = document.querySelector(".promo-bar-expandable.index");
                
                const promobarVisited = localStorage.getItem('promo-bar-visited');
                if (!promobarVisited) {
                    if(promoBarShippingContainer){
                        promoBarShippingContainer.style.setProperty("--promo-display",  "block" );
                        localStorage.setItem('promo-bar-visited', true);
                    }
                }
            };
    
            updatePromoBarVisibility();
            
            // slider.events.on('indexChanged', function() {
            //     updatePromoBarVisibility();
            // });

            let promoBarBtn = document.querySelector('.promo-bar-play-pause');

            if (promoBarCells.length > 1) {
                promoBarBtn.style.display = "";

                promoBarBtn.addEventListener('click', function (e) {
                    if (isPlaying) {
                        slider.pause();
                        isPlaying = false;
                        promoBarMain.classList.add('promo-bar-paused');
                        promoBarBtn.setAttribute("aria-label", "Play slide rotation");
                    } else {
                        promoBarMain.classList.remove('promo-bar-paused');
                        promoBarBtn.setAttribute("aria-label", "Pause slide rotation");
                        slider.play();
                        isPlaying = true;
                    }
                });

                promoBarBtn.addEventListener('keydown', e => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        promoBarBtn.click();
                    }
                });
            } else {
                if (promoBarBtn) promoBarBtn.style.display = "none";
            }
        }
    }

    initializePromoSlider();

    if (document.querySelector('.promo-holiday-banner')) {
        document.querySelectorAll('.promo-holiday-banner a').forEach(function (element) {
            element.addEventListener('click', function (event) {
                event.stopPropagation();
            });
        });

        document.querySelector('.promo-holiday-banner.promo-holiday-banner-icon').addEventListener('click', function (event) {
            var calpakStorage = window.sessionStorage;
            localStorage.setItem('holiday-banner-stop-animation', 1);
            document.querySelector('.promo-holiday-banner .arrow').classList.remove('start-animation');
            document.querySelector('.promo-holiday-banner .arrow').classList.add('stop-animation');
            event.preventDefault();
            if (this.classList.contains('promo-expanded')) {
                document.body.classList.remove('shipping-banner-on');
                this.classList.remove('promo-expanded');
                if (document.querySelector('.holiday-banner-dates')) document.querySelector('.holiday-banner-dates').classList.toggle('show');
                document.querySelector('.promo-bar').classList.toggle('holiday-banner-open');
            } else {
                document.body.classList.add('shipping-banner-on');
                this.classList.add('promo-expanded');
                document.querySelector('.promo-bar').classList.toggle('holiday-banner-open');
                if (document.querySelector('.holiday-banner-dates')) document.querySelector('.holiday-banner-dates').classList.toggle('show');
            }
        });
        if (document.getElementById("dates")) {
            let dateFromText = document.getElementById("dates").innerText;
            let dates = JSON.parse(dateFromText);
            var now = new Date().getTime();

            for (let i = 0; i < dates.length; i++) {
                var countDownDate = new Date(dates[i]);
                var countDownTime = countDownDate.getTime();
                //var offset = countDownDate.getTimezoneOffset() * 60 * 1000;

                // Adjust for the PT timezone offset (8 hours)
                //offset -= 8 * 3600 * 1000;

                var distance = countDownTime - now;

                if (distance < 0) {
                    document.querySelectorAll('.holiday-banner-date')[i].classList.add('inactive');
                    document.querySelectorAll('.holiday-banner-date')[i].style.order = 2;
                }
            }
        }

    }

    const body = document.body;
    const promoSection = document.getElementById('shopify-section-promo-bar');

// new MutationObserver((mutations) => {
//     mutations.forEach((mutation) => {
//       if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
//         if (document.body.classList.contains('modal-open')) {
//           document.getElementById('shopify-section-promo-bar').style.display = 'none';
//         } else {
//           document.getElementById('shopify-section-promo-bar').style.display = 'block';
//         }
//       }
//     });
//   }).observe(document.body, { attributes: true });

// document.addEventListener('DOMContentLoaded', function() {
    // const navbar = document.querySelector('.header-container'); 1-09-2023
    const navbar = document.querySelector('.header_main-sticky');
    const stickyElement = document.querySelector('.collection-filters__section');
    const stickyElement2 = document.querySelector('.pdp__floating-submit')
    const bodyElement = document.querySelector('body');
    const navElement = document.querySelector('.site-header__nav > ul.header__nav--full');
    const mobileMenuElement = document.querySelector('.mobile-menu .menu-close');
    const mobileMenu = document.querySelector('.mobile-menu');


    const observernav = new ResizeObserver(entries => {
        for (let entry of entries) {
            if (entry.target === navbar) {
                const navbarHeight = navbar.offsetHeight;
                stickyElement.style.top = navbarHeight + "px";
            }
        }
    });

    const observerSticky2 = new ResizeObserver(entries => {
        for (let entry of entries) {
            if (entry.target === stickyElement2) {
                const navbarHeight = navbar.offsetHeight;
                if (window.innerWidth <= 900) {
                    stickyElement2.style.top = 'auto';
                } else {
                    stickyElement2.style.top = "60px";//navbarHeight + "px";// navbarHeight > 60 ? '90px' : '60px';
                    // add extra spacing for gamification banner
                    //stickyElement2.style.top = navbarHeight > 60 ? '172px' : '42px';
                }
            }
        }
    });

    // const observer = new MutationObserver((mutations) => {
    //     mutations.forEach((mutation) => {
    //       if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
    //         if (window.innerWidth <= 900) {
    //           if (bodyElement.classList.contains('modal-open')) {
    //             navElement.style.display = 'flex';
    //           }  else {
    //               navElement.style.display = 'none';
    //           }
    //         }
    //       }
    //     });
    // });

    //   observer.observe(bodyElement, { attributes: true });      
    // if (window.innerWidth <= 900){
    //     if (bodyElement.classList.contains('modal-open')) {
    //         navElement.style.display = 'flex';
    //     } else {
    //         navElement.style.display = 'none';   
    //     }
    // }


    if (stickyElement) observernav.observe(navbar);
    if (stickyElement2) observerSticky2.observe(stickyElement2);
// });

    const promoBarShippingContainer = document.querySelector(".promo-bar-expandable");
    const promoBarToggleBtn = document.querySelectorAll(".promo-bar-caret-btn");

    if (promoBarShippingContainer) {
    const template = promoBarShippingContainer.getAttribute("data-template");

    if (template && template !== "index") {
        promoBarShippingContainer.style.setProperty("--promo-display", "none");
    } else {
        promoBarToggleBtn?.forEach((btn) => {
        let svg = btn.querySelector("svg");
        if (svg) svg.style.transform = "rotate(0deg)";
        });
        const handleScroll = () => {
        const shouldHide = window.scrollY > 10;
        if (shouldHide) {
            promoBarShippingContainer.style.setProperty("--promo-display", "none");

            promoBarToggleBtn?.forEach((btn) => {
            let svg = btn.querySelector("svg");
            if (svg) svg.style.transform = "rotate(180deg)";
            });
            //window.removeEventListener("scroll", handleScroll);
        }
        };

        window.addEventListener('scroll', handleScroll);
    }
    }

    if (promoBarToggleBtn?.length) {
    promoBarToggleBtn?.forEach((btn) => {
        btn.addEventListener("click", () => {
        const currentDisplay = promoBarShippingContainer.style.getPropertyValue("--promo-display") || "block";
        const shouldHide = currentDisplay === "block";

        promoBarShippingContainer.style.setProperty("--promo-display", shouldHide ? "none" : "block");
        let svg = btn.querySelector("svg");
        if (svg) svg.style.transform = svg.style.transform === "rotate(0deg)" ? "rotate(180deg)" : "rotate(0deg)";
        })
    });
    }
});
